import { Link, useSearchParams } from 'react-router-dom';

import {
  FetchLoading,
  InfiniteScrollSentinel,
  List,
  PullToRefresh,
} from '@/shared/component';
import { QUERY_KEY, STALE_TIME } from '@/shared/constant';
import { useSuspenseInfiniteScroll } from '@/shared/hook';

import { PostBar } from '@/feature/board/component';

import { getExamReviewList } from '@/apis';

import styles from './SearchExamReviewList.module.css';

export default function SearchExamReviewList() {
  const [searchParams] = useSearchParams();
  const params = Object.fromEntries(searchParams.entries());

  const {
    items: examList,
    ref,
    isFetchingNextPage,
    refetch,
  } = useSuspenseInfiniteScroll({
    queryKey: [QUERY_KEY.reviews, JSON.stringify(params)],
    queryFn: ({ pageParam }) =>
      getExamReviewList({
        page: pageParam,
        params,
      }),
    staleTime: STALE_TIME.searchList,
    getItemKey: (item) => item.postId,
  });

  if (examList.length === 0 && !isFetchingNextPage) {
    const error = new Error('검색 결과가 없습니다.');
    error.status = 404;
    throw error;
  }

  return (
    <PullToRefresh onRefresh={refetch}>
      <List className={styles.examReviewList}>
        {examList.map((post) => (
          <Link
            className={styles.to}
            key={post.postId}
            to={`/board/exam-review/post/${post.postId}`}
          >
            <PostBar {...post} content={post.questionDetail}>
              {post.isConfirmed && <PostBar.ConfirmedChip />}
            </PostBar>
          </Link>
        ))}

        <InfiniteScrollSentinel ref={ref} />
        {isFetchingNextPage && <FetchLoading />}
      </List>
    </PullToRefresh>
  );
}
